import { Checkbox } from 'platform/components';
import { MouseEvent } from 'react';
import { SELECTION_COLUMN_WIDTH, SELECTION_TEST_ID_PREFIX } from '../../../../../../constants/selectionColumn';
interface RowSelectCheckboxProps {
  isSelected: boolean;
  /** Row ID forwarded to onToggleSelection — avoids creating an inline arrow at the call site. */
  rowId: string;
  onToggleSelection: (rowId: string) => void;
  rowIndex?: number;
}
export function RowSelectCheckbox(props: RowSelectCheckboxProps) {
  const handleClick = (event: MouseEvent) => {
    event.stopPropagation();
  };
  const handleChange = () => {
    props.onToggleSelection(props.rowId);
  };
  return <td className="p-0 text-center select-none bg-white" style={{
    width: SELECTION_COLUMN_WIDTH,
    position: 'sticky',
    left: 0,
    zIndex: 'var(--z-content)'
  }} onClick={handleClick}>
      <div className="flex items-center justify-center h-full">
        <Checkbox value={props.isSelected} onChange={handleChange} data-testid={`${SELECTION_TEST_ID_PREFIX}-row-${props.rowIndex ?? 0}`} />
      </div>
    </td>;
}